import { SagaIterator } from 'redux-saga';
import { takeLatest } from 'redux-saga/effects';
import { workerGetContractsList } from './workers';
import { getContractsList } from '../actions';

export default function* watchContracts(): SagaIterator {
  yield takeLatest(getContractsList, workerGetContractsList);
}
